import React, { Component } from 'react'

// subcomponent
import FilterBar from './filterbar'
import SelectTier from './select_tier'
import ListReport from './list_reports'
import HeadBar from './headbar'
import Paginate from './paginate'

// lib
import { Row, Col } from 'antd'

// redux
import { connect } from 'react-redux'
import ReportActions from '../../../redux/report/actions'

class ListInputReports extends Component {
    componentDidMount() {
        this.props.loadListReport()
    }

    render() {
        return (
            <div className="ListInputReports">
                <Row>
                    <Col xl={6} style={{ textAlign: 'left' }}>
                        <HeadBar />
                        <FilterBar />
                    </Col>
                    <Col xl={18}>
                        <SelectTier />
                        <ListReport />
                        <Paginate />
                    </Col>
                </Row>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {}
}

const mapDispatchToProps = dispatch => {
    return {
        loadListReport: () => {
            dispatch(ReportActions.action.loadListReport({}))
        },
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ListInputReports)
